import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import "../../../../assets/css/cms/Products.css";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { Form, Row, Col } from "react-bootstrap";
import { Alert } from "@mui/material";
import { connect } from "react-redux";
import Loading from "../../../utils/loader";
import { CUSTOM_STYLE_PERMISSION_DATA_TABLE } from "../../../../constants/cms";
import {
  getProductDialer,
  postProductDialer,
  getproductTitle,
} from "../../../../../store/slices/pushDialer";

function ManageProductDialer(props) {
  const [tableData, setTableData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [formikValue, setFormikValues] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [debounceState, setDebounceState] = useState("");

  const productTypeOptions = [
    { value: "result_predictor", label: "Result Predictor" },
    { value: "college_predictor", label: "College Predictor" },
    { value: "mba_college_predictor", label: "MBA College Predictor" },
  ];

  const costTypeOptions = [
    { value: "Free", label: "Free" },
    { value: "Paid", label: "Paid" },
  ];

  const tableCustomData = [
    {
      name: "Product Title",
      selector: (row) => row.title,
      minWidth: "350px",
    },
    {
      name: "Product Type",
      selector: (row) => row.type,
      center: true,
    },
    {
      name: "Product Amount",
      selector: (row) => row.price,
      center: true,
    },
    {
      name: "Manage Push",
      center: true,
      cell: (row) => (
        <div className="toggle-switch">
          <label className="switch">
            <input
              type="checkbox"
              checked={row.push_to_dialer === 1}
              onChange={() => handleToggle(row)}
            />
            <span className="slider round"></span>
          </label>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  useEffect(() => {
    if (currentPage) {
      const params = {
        page_number: currentPage,
        page_size: perPage,
        type: formikValue?.product_type?.value?.toLowerCase() || null,
        title: formikValue?.title || null,
        price: formikValue?.cost_type?.value || null,
      };

      props.dispatch(getProductDialer(params));
    }
  }, [currentPage]);

  useEffect(() => {
    if (props.productDialerData) {
      const data = props.productDialerData;
      if (data?.products) setTableData(data.products);
      if (data?.total_items) setTotalItems(data.total_items);
    }
  }, [props.productDialerData]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    const params = {
      page_number: page,
      page_size: newPerPage,
      type: formikValue?.product_type?.value || null,
      title: formikValue?.title || null,
      price: formikValue?.cost_type?.value || null,
    };
    props.dispatch(getProductDialer(params));
    setPerPage(newPerPage);
  };

  //MANAGE PUSH TOGGLE
  const handleToggle = (row) => {
    const updatedValue = row.push_to_dialer === 1 ? 0 : 1;

    const updatedData = tableData.map((product) =>
      product.id === row.id
        ? { ...product, push_to_dialer: updatedValue }
        : product
    );
    setTableData(updatedData);
  };

  //FOR SAVE
  const handleSave = () => {
    const activeProducts = tableData
      .filter((product) => product.push_to_dialer === 1)
      .map((product) => product.id);

    const deactiveProducts = tableData
      .filter((product) => product.push_to_dialer === 0)
      .map((product) => product.id);

    const totalActivated = activeProducts.length;
    const totalDeactivated = deactiveProducts.length;

    if (totalActivated > 0 || totalDeactivated > 0) {
      const params = {
        active_products: activeProducts,
        deactive_products: deactiveProducts,
      };

      props.dispatch(postProductDialer(params));
    }
  };

  //FOR ALERT POPUP TO DISAPPEAR AFTER 3SEC
  useEffect(() => {
    if (props.postDialerData || props.postDialerError) {
      setShowAlert(true);

      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // 3 seconds

      return () => clearTimeout(timer);
    }
  }, [props.postDialerData, props.postDialerError]);

  useEffect(() => {
    if (props.postDialerData) {
      const params = {
        page_number: currentPage,
        page_size: perPage,
        type: formikValue?.product_type?.value?.toLowerCase() || null,
        title: formikValue?.title?.title || null,
        price: formikValue?.cost_type?.value || null,
      };

      props.dispatch(getProductDialer(params));

      props.dispatch(getproductTitle());
    }
  }, [props.postDialerData]);

  const handleOnInputChangeFields = (title, value) => {
    let params = {};
    params[title] = value;
    let inDebounce = debounceState;
    if (title === "title" && value) {
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => {
        props.dispatch(getproductTitle(params));
      }, 1000);
      setDebounceState(inDebounce);
    }
  };

  useEffect(() => {
    props.dispatch(getproductTitle());
  }, []);
  return (
    <>
      <div className="examfilter_heading">
        <h4>Manage Products to Dialer</h4>
      </div>
      {showAlert && (
        <div className="notification_popup">
          <Alert severity={props.postDialerError ? "error" : "success"}>
            {props.postDialerError
              ? props.postDialerError
              : "Products Updated Successfully"}
          </Alert>
        </div>
      )}

      <div className="summary-boxes">
        <div className="summary-box">
          <span className="TotalCount">
            {props.productDialerData?.total_active_products ?? 0}
          </span>
          <br />
          Total Active Products
        </div>
        <div className="summary-box">
          <span className="TotalCount">
            {props.postProductTitleData?.total_pushed_products ?? 0}
          </span>
          <br />
          Total Products pushed to Dialer
        </div>
      </div>

      <div className="examfilter">
        <Formik
          enableReinitialize
          initialValues={{
            title: null,
            product_type: null,
            cost_type: null,
          }}
          onSubmit={(values) => {
            setFormikValues(values);
            const filters = {
              page_number: currentPage,
              page_size: perPage,
              type: values?.product_type?.value || null,
              title: values?.title?.title || null,
              price: values?.cost_type?.value || null,
            };
            props.dispatch(getProductDialer(filters));
          }}
        >
          {({ handleSubmit, handleChange, values, setFieldValue }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={4}>
                    <Form.Group>
                      <label className="Dialer_form_label">Product Type</label>
                      <Select
                        name="title"
                        placeholder="Search by Title"
                        value={values.title}
                        onInputChange={(value) => {
                          handleOnInputChangeFields("title", value);
                        }}
                        onChange={(option) => setFieldValue("title", option)}
                        options={props?.postProductTitleData?.products}
                        getOptionLabel={(option) => option?.title}
                        getOptionValue={(option) => option?.id}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="Dialer_form_label">Product Type</label>
                      <Select
                        name="product_type"
                        value={values.product_type}
                        placeholder="Filter by Product Type"
                        onChange={(option) =>
                          setFieldValue("product_type", option)
                        }
                        options={productTypeOptions}
                        isClearable={true}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="Dialer_form_label">Cost Type</label>
                      <Select
                        name="cost_type"
                        value={values.cost_type}
                        placeholder="Filter by Cost Type"
                        onChange={(option) =>
                          setFieldValue("cost_type", option)
                        }
                        options={costTypeOptions}
                        isClearable={true}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="manage_ranking_button_cover">
                      <button
                        type="submit"
                        className="exam_button rounded-pill"
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="exam_button rounded-pill"
                        onClick={() => {
                          setFieldValue("title", "");
                          setFieldValue("product_type", null);
                          setFieldValue("cost_type", null);
                          setCurrentPage(1);
                          props.dispatch(getProductDialer());
                        }}
                      >
                        Clear
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </div>

      <div className="all_task" style={{ marginTop: "40px" }}>
        <div className="examfilter">
          <div className="tablestrip">
            <div className="tablestrip_left">
              <h4 className="examfilter_heading">Manage Push</h4>
            </div>
          </div>

          <div className="exam_table_box" style={{ marginTop: "20px" }}>
            <DataTable
              columns={tableCustomData}
              data={tableData}
              progressPending={props.productDialerLoading}
              customStyles={CUSTOM_STYLE_PERMISSION_DATA_TABLE}
              pagination
              paginationServer
              paginationPerPage={perPage}
              paginationTotalRows={totalItems}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
            />
          </div>
          {(tableData || []).length > 0 && (
            <div className="manage_ranking_button_cover">
              <button
                className="exam_button"
                type="submit"
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  productDialerData: state.DialerReducer.productDialerData,
  productDialerLoading: state.DialerReducer.productDialerLoading,
  postDialerData: state.DialerReducer.postDialerData,
  postDialerError: state.DialerReducer.postDialerError,
  postProductTitleData: state.DialerReducer.productTitleData,
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageProductDialer);
